const U = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=500`;

// Foto caricate dal cliente (libreria "The Cube")
const A = "https://customer-assets-lxgj4vgw.emergentagent.net/job_qr-menu-pro-13/artifacts/";
const CUSTOM = {
  antipasto: A + "l0jnn7c1_a741f67a2de7915cb2771b218df19c3b.jpg",
  insalata: A + "2wkd6yxs_970172f0ad779a42fe82c459c95c849b.jpg",
  pizza: A + "6uqqoa3g_50aed424fb7465bd55daac0986115db3.jpg",
  pesce: A + "606a782u_25b73d9595537095bc14ffe6f806b18b.jpg",
  vino: A + "sz87geaq_bf6ff5a406f3796778d5e89f6b3fc40e.jpg",
  carne: A + "1775bl0c_f9a501492e67a6a22b7aab52cda4ba0b.jpg",
  fritti: A + "5cfldltb_8c25e0a3a165bec4f40c4552677cbaf9.jpg",
  pasta: A + "oml5dsx8_ddd5ea939b837fbebc7ff1a211e2e42e.jpg",
  dolce: A + "3d0odr34_8762869425514c4122b237a15f24f1a6.jpg",
  vino_bianco: A + "dr103rum_61b32cf42eb0abc117cb984f3d4b8f86.jpg",
  vino_rosso: A + "5huexa9g_3b6c8af4531ef5c3fab10eb45a93304c.jpg",
  vino_rose: A + "7hj8ns3y_01ac4ae2ea43d3f8a81da8d29a896e6d.jpg",
  vino_spumante: A + "mtcs7v6s_e9b04494efb7f3c6fd62e21648d6b154.jpg",
  // Nuove foto caricate
  insalata_cavolo: A + "w6mmj3ji_0af04b8ae651a92478d0c7016c478ac7.jpg",
  insalata_greca: A + "way0p0ot_e7729ce061c71103d5dd2547722c55fe.jpg",
  fusilli: A + "njz4u31x_d43a08afaebee9e730174cb04695a32a.jpg",
  verdure_grigliate: A + "0qsyvb8m_b4e97b0a6d3f86690f4c3679659ee7c8.jpg",
  cocacola: A + "nxo1yzw0_9838f8eb9074b0d770f5dc8f2f58d5c0.jpg",
  gin_verde: A + "id3x3tha_gin-tonic-in-cucina-con-federico.jpg",
  gin_classico: A + "skp3z8vv_360_F_390899758_WyiVDB60EmkW7bup1Inifuqts3Ie8XpU.jpg",
  bistecca: A + "1c1x68wr_51f6b972c60576fe66527774a28da687_edited.jpg",
  gelato_mirtillo: A + "3j690olb_fcc807977111d915cb385b79fa205039_edited.jpg",
  caffe: A + "ix0o1jlm_2befb48d18a60678e68f6f5a6b8240ad_edited.jpg",
  toast_prosciutto: A + "o285ft3e_da8054ecac17bf08106923aeaf7d85ab.jpg",
  frappe_cioccolato: A + "rgrdm9sb_6f31cad21340255402d59381631d0a41.jpg",
  frutta_fresca: A + "kwdwj22b_a112e7a1b58a3a7ca4df24104ea398bd.jpg",
  pizza_forno: A + "qqahk24m_cac42066f643ddeeae8ca1c7e2eb1956.jpg",
  cocktail_cheers: A + "gkzrm2sz_6438db46ee727339559f0c211b87b9fd.jpg",
  caprese_ciabatta: A + "uebczzde_af1d5d946d795d38746744c5f77faf46.jpg",
  focaccia_pomodorini: A + "qqe416eq_07b38f7ca7975ca6b953e9f8ad10236c.jpg",
  bistecca_vino: A + "l3bpxgo0_bbe5ab741df19470b3c9057c8d11834c.jpg",
  spaghetti_pomodoro: A + "m0g3o7rc_53b54759a906ddd964895d08d0ae24b8.jpg",
  insalata_salmone: A + "hmyaknd7_c5f7fee4ff8d256a4a0b914663dba2ae.jpg",
  // Nuovo lotto: birra e liquori
  birra: A + "8ohygivk_d84d94d92bd3a5ca456040ec7b010720.jpg",
  grappa: A + "zybutagj_732ffef1c34d61e4106234ef3febf645.jpg",
  whiskey: A + "d1pg1fzy_5f0a949b6930648ff653f0642a34eeb4.jpg",
  tequila_shot: A + "8j6i1l1k_6e91e949853d05cf86c00408b04b747e.jpg",
  cognac_sigaro: A + "xu5ikida_5ca0b3eddb3696a2645ca08232fa65b0.jpg",
  // Lotto caffè/champagne/polpo/patatine/pizza
  caffe_top: A + "o69em32g_233033b82c9bdf6e86ceeab29ef06bbd.jpg",
  champagne: A + "8ok788nr_07ed2932b6aa09b7ec0299505aa423db.jpg",
  polpo_nero: A + "4p0u8bao_aa815a68ca09dca343f9912053297511.jpg",
  patatine_fritte: A + "qroc67o3_78a4ed3e5cb29d3d15ff053785ccc5e0.jpg",
  pizza_bimbo: A + "v5lgu3ud_eed4fddd4e38691a987567d10d2519d8.jpg",
  // Lotto aragosta/spritz/digestivo/risotto/acqua
  aragosta: A + "d8528uo7_57a9b3fc301fd7bba31ed8e679e76582.jpg",
  spritz_cheers: A + "grm99s88_e33d793439e49422b1a5f42a0922c85c.jpg",
  digestivo_erbe: A + "7mg8ewya_ce640418d8ad32d8b57f7209193a8771.jpg",
  risotto_asparagi: A + "0gh6ty7x_6538bb91252cda95047cb9aa8fc0d123.jpg",
  acqua_frizzante: A + "x4wbusb1_98aee64c5870fcf7533d3c0f7b56df33.jpg",
};

export const STOCK_PHOTOS = {
  pasta: [CUSTOM.risotto_asparagi, CUSTOM.spaghetti_pomodoro, CUSTOM.pasta, CUSTOM.fusilli, CUSTOM.polpo_nero, U("1516100882582-96c3a05fe590"), U("1621494268492-d01b98eba7e4"), U("1663530761401-15eefb544889")],
  pizza: [CUSTOM.pizza_forno, CUSTOM.pizza, CUSTOM.pizza_bimbo, U("1587085416963-22efba033dd5"), U("1762922425256-621f056e1ebb"), U("1589187151053-5ec8818e661b")],
  carne: [CUSTOM.bistecca_vino, CUSTOM.bistecca, CUSTOM.carne, U("1663530761401-15eefb544889"), U("1616671285410-2a676a9a433d"), U("1621494268492-d01b98eba7e4")],
  fritti: [CUSTOM.patatine_fritte, CUSTOM.fritti, U("1573080496219-bb080dd4f877"), U("1630431341973-02e1b662ec35")],
  pesce: [CUSTOM.aragosta, CUSTOM.polpo_nero, CUSTOM.pesce, U("1665401015549-712c0dc5ef85"), U("1716816211582-ef70b1cd2e70"), U("1663530761401-15eefb544889")],
  insalata: [CUSTOM.insalata_salmone, CUSTOM.insalata_greca, CUSTOM.insalata_cavolo, CUSTOM.insalata, U("1512621776951-a57141f2eefd"), "https://images.pexels.com/photos/3070968/pexels-photo-3070968.jpeg?auto=compress&w=500", "https://images.pexels.com/photos/34618719/pexels-photo-34618719.jpeg?auto=compress&w=500"],
  contorno: [CUSTOM.verdure_grigliate, CUSTOM.patatine_fritte, U("1512621776951-a57141f2eefd")],
  antipasto: [CUSTOM.caprese_ciabatta, CUSTOM.focaccia_pomodorini, CUSTOM.toast_prosciutto, CUSTOM.antipasto, U("1707910072149-5ce3fe8d139e"), U("1611571940159-425a28706d6f"), U("1616671285410-2a676a9a433d")],
  dolce: [CUSTOM.frutta_fresca, CUSTOM.gelato_mirtillo, CUSTOM.dolce, U("1673912402587-57ac40f1b4a5"), U("1700482006355-ad309eff83ed"), U("1660230687259-ab2821e7480c")],
  drink: [CUSTOM.spritz_cheers, CUSTOM.cocktail_cheers, CUSTOM.gin_verde, CUSTOM.gin_classico, CUSTOM.birra, CUSTOM.whiskey, CUSTOM.grappa, CUSTOM.tequila_shot, CUSTOM.cognac_sigaro, U("1607622750671-6cd9a99eabd1"), U("1597075687490-8f673c6c17f6"), U("1566417713940-fe7c737a9ef2")],
  aperitivo: [CUSTOM.spritz_cheers, CUSTOM.cocktail_cheers],
  gin: [CUSTOM.gin_verde, CUSTOM.gin_classico],
  birra: [CUSTOM.birra],
  liquori: [CUSTOM.digestivo_erbe, CUSTOM.whiskey, CUSTOM.grappa, CUSTOM.cognac_sigaro, CUSTOM.tequila_shot],
  bibite: [CUSTOM.acqua_frizzante, CUSTOM.frappe_cioccolato, CUSTOM.cocacola, CUSTOM.birra, U("1607622750671-6cd9a99eabd1"), U("1566417713940-fe7c737a9ef2")],
  acqua: [CUSTOM.acqua_frizzante],
  caffe: [CUSTOM.caffe_top, CUSTOM.caffe],
  vino: [CUSTOM.champagne, CUSTOM.vino_bianco, CUSTOM.vino_rosso, CUSTOM.vino_rose, CUSTOM.vino_spumante, CUSTOM.vino],
};
